import React from 'react';
import axios from "axios";
import ReportsError from './ReportsError';
import {
    appendScript,
    getPercentageChange
} from './Utilities';

class ReportsLoginTrends extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            "all_time": "",
            "current": {
                "total": "", 
                "set": false
            },
            "previous": {
                "total": "", 
                "set": false
            },
            "percentages":{
                "percentageChange" : "",
                "direction": "",
                "set": false
            },
            error: null
        }
    }

    componentDidMount(){        
        this.getData();
        appendScript("thirdparty/Minton-assets/js/app.js");
    }

    componentDidUpdate(prevProps, prevState, snapshot){
        if((this.state.current.set && this.state.previous.set) && !this.state.percentages.set){
            this.calculatePercentageChanges();
        }
    }

    getData(){        
        var url = "react/process?endpoint=login/stats/totals&turnoffdebug=1&all_time=1";
        axios.get(url).then(response => this.formatData(response.data, "current"));

        var prev_url = "react/process?endpoint=login/stats/totals&turnoffdebug=1&PreviousPeriod=1";
        axios.get(prev_url).then(prev_response => this.formatData(prev_response.data, "previous"));
    }

    formatData(data, period){
        if(period === "current"){
            this.setState({
                "current": {"total": data.total, "set": true},
                "all_time": data.all_time_total
            });
        }
        if(data?.error) this.setState({error: data.error?.message});
        else if(period === "previous") this.setState({"previous": {"total": data.total, "set": true}});
    }

    calculatePercentageChanges(){
        var direction = "";
        var change = getPercentageChange(this.state.current.total, this.state.previous.total).toString();
        if(change.charAt(0) === "-"){
            change = change.slice(1);
            direction = "down";
        } else {
            direction = "up";
        }

        if(isNaN(change)) change = 0;

        this.setState({
            "percentages":{
                "percentageChange": change, 
                "direction": direction,
                "set": true
            }
        });
    }

    render() {
        var percentageClass = (this.state.percentages.direction === "up") ? "success" : "danger";

        if(this.state.error){
            return (
                <ReportsError error={this.state.error} table="false" />
            );
        } else {
            return (
                <React.Fragment>

                    <h5 className="text-muted fw-normal mt-3 mb-0 text-truncate" title="">Total Logins</h5>
                    
                    <p className="overview-numbers">
                        <span data-plugin="counterup" className="min-width-60 number">{this.state.all_time}</span>
                    </p>
                    <h5 className="text-muted fw-normal mt-3 mb-0 text-truncate" title="">Logins for current period</h5>
                    <p className="overview-numbers">
                        <span data-plugin="counterup" className="min-width-60 number">{this.state.current.total}</span>
                        <span className={"text-"+percentageClass+" me-2"}>
                            <span className={"mdi mdi-arrow-"+this.state.percentages.direction+"-bold"}></span>
                            {this.state.percentages.percentageChange}%
                        </span>
                    </p>

                </React.Fragment>
            );
        }
    }
}

export default ReportsLoginTrends;
